/* Mama's Daily home sections: header, mobile menu and FAQ behaviour.
   Uses event delegation so everything keeps working when sections are
   re-rendered in the theme editor. */
(function () {
  'use strict';
  if (window.__mdhLoaded) return;
  window.__mdhLoaded = true;

  // Sticky header shadow once the page scrolls. Horizon scrolls .page-wrapper
  // on wide screens and the window on small screens, so listen to both.
  function scrollTop() {
    var wrapper = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
  }
  function updateHeader() {
    var top = scrollTop();
    document.querySelectorAll('.mdh-head').forEach(function (head) {
      head.classList.toggle('mdh-scrolled', top > 8);
    });
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  });

  function closeMenu(head) {
    var nav = head.querySelector('.mdh-nav');
    var btn = head.querySelector('.mdh-menu-btn');
    if (!nav || !btn) return;
    nav.classList.remove('mdh-open');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', btn.dataset.openLabel || 'Open menu');
  }

  document.addEventListener('click', function (event) {
    // Mobile menu toggle
    var btn = event.target.closest('.mdh-menu-btn');
    if (btn) {
      var head = btn.closest('.mdh-head');
      var nav = head && head.querySelector('.mdh-nav');
      if (!nav) return;
      var open = nav.classList.toggle('mdh-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? btn.dataset.closeLabel || 'Close menu' : btn.dataset.openLabel || 'Open menu');
      return;
    }
    // Close the menu after choosing a link
    var link = event.target.closest('.mdh-nav a');
    if (link) closeMenu(link.closest('.mdh-head'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mdh-head').forEach(closeMenu);
  });

  // FAQ: keep one answer open at a time within each section
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      var acc = details.closest('.mdh-acc');
      if (!acc || acc.dataset.single !== 'true') return;
      acc.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    },
    true
  );

  // Theme editor: highlight the block being edited
  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target.closest && event.target.closest('.mdh-acc details');
    if (details) details.open = true;
  });
  document.addEventListener('shopify:section:load', updateHeader);
})();
